import { IDEA_STATUSES } from '@cult/domain';
import type { IdeaStatus } from '@cult/schemas';
import { Tag } from 'antd';

const STATUS_COLOR: Record<IdeaStatus, string> = {
  [IDEA_STATUSES.PENDING]: 'blue',
  [IDEA_STATUSES.APPROVED]: 'success',
  [IDEA_STATUSES.REJECTED]: 'error',
};

const STATUS_LABEL: Record<IdeaStatus, string> = {
  [IDEA_STATUSES.PENDING]: 'Pending',
  [IDEA_STATUSES.APPROVED]: 'Approved',
  [IDEA_STATUSES.REJECTED]: 'Rejected',
};

type Props = {
  status: IdeaStatus;
  // Override the default label (e.g. "Suggested" for pending in member stats).
  label?: string;
};

export const IdeaStatusTag = ({ status, label }: Props) => {
  return (
    <Tag color={STATUS_COLOR[status]} style={{ marginRight: 0, padding: '2px 10px' }}>
      {label ?? STATUS_LABEL[status]}
    </Tag>
  );
};
